import api from './index'

// 项目相关API
export const getProjects = (params = {}) => api.get('/projects', { params })

export const createProject = (data) => api.post('/projects', data)

export const getProject = (id) => api.get(`/projects/${id}`)

export const updateProject = (id, data) => api.put(`/projects/${id}`, data)

export const deleteProject = (id) => api.delete(`/projects/${id}`)

export const uploadTextFile = (id, file) => {
  const formData = new FormData()
  formData.append('file', file)
  
  return api.post(`/projects/${id}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 设定相关API
export const getSettings = (projectId) => api.get(`/projects/${projectId}/settings`).then(res => res.data || res)

export const extractSettings = (projectId, text, debug = false) => api.post('/settings/extract', {
  project_id: projectId,
  text,
  debug
})

export const saveSettings = (data) => api.post('/settings', data)

export const clearSettings = (projectId) => api.post('/settings/clear', { project_id: projectId })

// 剧本相关API
export const getScripts = (projectId) => api.get(`/projects/${projectId}/scripts`)

export const generateScripts = (projectId, text, settings) => api.post(`/projects/${projectId}/scripts`, {
  text,
  settings
})

export const saveScripts = (projectId, scenes) => api.post(`/projects/${projectId}/scripts/save`, {
  scenes
})

export const updateScript = (id, data) => api.put(`/scripts/${id}`, data)

// 语音相关API
export const generateVoice = (scriptId, speaker, text, characterName = '') => api.post(`/scripts/${scriptId}/voice`, { speaker, text, character_name: characterName })

export const getVoices = (projectId) => api.get(`/projects/${projectId}/voices`)

export const selectVoice = (voiceId) => api.post(`/voices/${voiceId}/select`)

// 图片相关API
export const splitImage = (imageUrl, gridSize, projectId, sceneId) => api.post('/images/split', {
  image_url: imageUrl,
  grid_size: gridSize,
  project_id: projectId,
  scene_id: sceneId
})

export const expandImage = (imageId, direction, expandPixels, prompt) => api.post(`/images/${imageId}/expand`, {
  direction,
  expand_pixels: expandPixels,
  prompt
})

export const getProjectImages = (projectId, sceneId) => api.get(`/projects/${projectId}/images`, {
  params: { scene_id: sceneId }
})

// 视频相关API
export const generateVideo = (projectId, sceneId, firstFrameUrl, lastFrameUrl, options) => api.post('/videos/generate', {
  project_id: projectId,
  scene_id: sceneId,
  first_frame_url: firstFrameUrl,
  last_frame_url: lastFrameUrl,
  options
})

export const checkVideoStatus = (videoId) => api.get(`/videos/${videoId}/status`)

export const composeVideo = (projectId, segments) => api.post(`/projects/${projectId}/compose`, {
  segments
})

export const getProjectVideos = (projectId) => api.get(`/projects/${projectId}/videos`)

// 提示词模板API
export const getPrompts = () => api.get('/prompts')

export const getPrompt = (type) => api.get(`/prompts/${type}`)

export const updatePrompt = (type, content, description) => api.put(`/prompts/${type}`, {
  content,
  description
})

// 系统状态API
export const getSystemStatus = () => api.get('/system/status')
